import type { IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createCsrfToken, createHeaders, fetchJsonQuery } from "@mne-core/api";

import AuthenticationURI from "./AuthenticationURIBuilder";

export interface IRequestAuthorizationTokenSMSResponse {
  cookie: string;
}

export interface IRequestAuthorizationTokenSMSOpts extends RequestInit {
  apiUrl: string;
  apiKey?: string;
  sessionKey: string;
  ctrl?: QueryController;
}

export const createRequest = (opts: IRequestAuthorizationTokenSMSOpts): Request => {
  const { apiUrl, apiKey, sessionKey, ...restOpts } = opts;
  const uri = new AuthenticationURI().setApiUrl(apiUrl).setSegment(["sms", "authorize"]);

  const headers = createHeaders({
    "ARGUS-API-KEY": apiKey,
    Accept: "application/json",
    "Content-type": "application/json",
    "ARGUS-CSRF-Token": !apiKey ? createCsrfToken(sessionKey, String(uri)) : false,
  });

  let localRequestOpts: RequestInit = {
    headers,
    method: "GET",
    mode: "cors",
  };

  if (!apiKey) {
    /**
     * Only add cookies if no apikey is provided
     */
    localRequestOpts = {
      ...localRequestOpts,
      credentials: "include",
    };
  }

  return new Request(String(uri), {
    ...localRequestOpts,
    ...restOpts,
  });
};

async function requestAuthorizationTokenSMS(
  opts: IRequestAuthorizationTokenSMSOpts,
): Promise<JsonQuery<IResultstash<IRequestAuthorizationTokenSMSResponse>>> {
  return fetchJsonQuery<IResultstash<IRequestAuthorizationTokenSMSResponse>>(createRequest(opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}

export default requestAuthorizationTokenSMS;
